var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"insights-chart-loader"},[_c('strong',{staticClass:"font-weight-medium"},[_vm._v("Loading...")])])
}]

export { render, staticRenderFns }